import React from 'react';
import PropTypes from 'prop-types';
// styles
import '../Styles/Styles.css';

export const CreativeListComponent = ({ data = [] }) => {

    const handleDownload = (item, index) => {
        try {
            const link = document.createElement('a');
            link.href = item?.source_link;
            link.download = item?.file_name || 'download'; // Set the file name for the download
            const newWindow = window.open(link.href, '_blank');
            if (newWindow) {
                newWindow.onload = () => {
                    newWindow.close();
                };
            } else {
                console.error('Failed to open new window');
            }
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    return (
        <div style={{ width: '60%', padding: '20px 0px' }}>
            {data?.map((item, index) =>
                !!item?.file_name && (<div key={item?.file_name}
                    className={`container`}
                >
                    <span className={`button-text`}>{item?.file_name}</span>
                    <button
                        className={`button-css`}
                        onClick={() => handleDownload(item, index)}
                    >
                        {'Download'}
                    </button>
                </div>)
            )}
        </div>
    )
}

CreativeListComponent.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            source_link: PropTypes.string.isRequired,
            file_name: PropTypes.string.isRequired,
        })
    ).isRequired,
};